import img10th from "../assets/images/marksheet-2-1.jpg";
import { Applicant, FilesInterface, FundsInterface } from "../types/types";

export const qualificationOptions = [
  "Below 10th",
  "10th Pass / Secondary School",
  "12th Pass / Higher Secondary",
  "Diploma / Polytechnic",
  "ITI / Vocational Training",
  "Undergraduate - Pursuing",
  "Bachelor's Degree (e.g., B.A., B.Sc., B.Com., B.Tech, BBA)",
  "Bachelor's (Honours)",
  "Integrated Master's (e.g., B.Tech + M.Tech)",
  "Postgraduate - Pursuing",
  "Master's Degree (e.g., M.A., M.Sc., M.Com., M.Tech, MBA)",
  "M.Phil.",
  "Ph.D. / Doctorate",
  "Post Doctoral",
  "Professional Degree (e.g., CA, CS, ICWA, LLB, MBBS)",
  "Other",
];
export const standardOptions = [
  "1st Standard",
  "2nd Standard",
  "3rd Standard",
  "4th Standard",
  "5th Standard",
  "6th Standard",
  "7th Standard",
  "8th Standard",
  "9th Standard",
  "10th Standard",
  "11th Standard",
  "12th Standard",
  "Diploma",
  "Graduation",
  "Post Graduation",
  "PhD",
];

export const streamOptions = [
  "Science",
  "Commerce",
  "Arts",
  "Humanities",
  "Vocational",
  "Engineering",
  "Medical",
  "Law",
  "Management",
  "IT / Computer Science",
  "Education",
  "Architecture",
  "Pharmacy",
  "Agriculture",
  "Design",
  "Mass Communication",
  "Other",
];

export const occupationOptions = [
  "Government Employee",
  "Private Sector Employee",
  "Business / Self-Employed",
  "Farmer / Agriculturist",
  "Daily Wage Worker",
  "Skilled Worker / Technician",
  "Unskilled Worker",
  "Teacher / Professor",
  "Medical Professional (Doctor, Nurse)",
  "Engineer / Architect",
  "Chartered Accountant / Financial Professional",
  "Lawyer / Legal Professional",
  "Armed Forces / Police",
  "Retired",
  "Homemaker",
  "Student",
  "Unemployed",
  "Deceased",
  "Other",
];
export const KnowApplicationData = [
  "Social Media",
  "Newspaper",
  "School/College",
  "Friend/Family",
  "Official Website",
  "Other",
];

export const Semesters = [
  "1st",
  "2nd",
  "3rd",
  "4th",
  "5th",
  "6th",
  "7th",
  "8th",
];

export const Durations = ["1 Year", "2 Years", "3 Years", "4 Years", "5 Years", "6 Years"];

export const Frequencies = ["Monthly", "Quarterly", "Half-Yearly", "Annually"];
export const FrequenciesFunds = ["Monthly", "Quarterly", "Half-Yearly", "Annually", "One-Time"];
export const statusOptions = [
  {
    value: "pending",
    label: "Pending", 
    studentLabel: "In review"
  },
  {
    value: "approved",
    label: "Approved", 
    studentLabel: "Approved"
  },
  {
    value: "rejected",
    label: "Rejected", 
    studentLabel: "Rejected"
  },
  {
    value: "pending_documents",
    label: "Pending Additional Documents", 
    studentLabel: "Pending Additional Documents"
  },
  {
    value: "document_submitted",
    label: "Document Submitted",  
    studentLabel: "In review"
  },
  {
    value: "scheduled_interview",
    label: "Scheduled for Interview", 
    studentLabel: "Scheduled for Interview"
  },
  {
    value: "draft",
    label: "Draft", 
    studentLabel: "Draft"
  }
];
export const summaryStatusOptions = [
  {
    value: "active",
    label: "Active", 
    studentLabel: "Active"
  },
  {
    value: "on_hold",
    label: "Hold", 
    studentLabel: "Hold"
  },
  {
    value: "cancelled",
    label: "Cancelled", 
    studentLabel: "Cancelled"
  },
  {
    value: "completed",
    label: "Completed", 
    studentLabel: "Completed"
  },
]

 

export const applicantData: Applicant[] = [
  {
    appId: 10001,
    name: "Anirban Ghosh",
    phone: "+91-9831012345",
    status: "Pending",
    college: "Presidency University",
    district: "Kolkata",
    state: "West Bengal",
    achievement: "Yes",
    stream: "Arts",
    evaluationStatus: "yes",
  },
  {
    appId: 10002,
    name: "Riya Sen",
    phone: "+91-9831023456",
    status: "Approved",
    college: "Jadavpur University",
    district: "North 24 Parganas",
    state: "West Bengal",
    achievement: "Yes",
    stream: "Science",
    evaluationStatus: "no",
  },
  {
    appId: 10003,
    name: "Subham Das",
    phone: "+91-9831034567",
    status: "Rejected",
    college: "-",
    district: "Howrah",
    state: "West Bengal",
    achievement: "No",
    stream: "Commerce",
    evaluationStatus: "yes",
  },
  {
    appId: 10004,
    name: "Tanushree Dutta",
    phone: "+91-9831045678",
    status: "Approved",
    college: "Rabindra Bharati University",
    district: "South 24 Parganas",
    state: "West Bengal",
    achievement: "Yes",
    stream: "Arts",
    evaluationStatus: "yes",
  },
  {
    appId: 10005,
    name: "Amitava Chatterjee",
    phone: "+91-9831056789",
    status: "Pending",
    college: "University of Calcutta",
    district: "Kolkata",
    state: "West Bengal",
    achievement: "No",
    stream: "Science",
    evaluationStatus: "yes",
  },
  {
    appId: 10006,
    name: "Soma Mukherjee",
    phone: "+91-9831067890",
    status: "Approved",
    college: "Vidyasagar University",
    district: "Paschim Medinipur",
    state: "West Bengal",
    achievement: "Yes",
    stream: "Engineering",
    evaluationStatus: "no",
  },
  {
    appId: 10007,
    name: "Rakesh Roy",
    phone: "+91-9831078901",
    status: "Pending",
    college: "Kalyani University",
    district: "Nadia",
    state: "West Bengal",
    achievement: "No",
    stream: "Science",
    evaluationStatus: "yes",
  },
  {
    appId: 10008,
    name: "Priyanka Dey",
    phone: "+91-9831089012",
    status: "Approved",
    college: "North Bengal University",
    district: "Darjeeling",
    state: "West Bengal",
    achievement: "Yes",
    stream: "Commerce",
    evaluationStatus: "no",
  },
  {
    appId: 10009,
    name: "Debanjan Sarkar",
    phone: "+91-9831090123",
    status: "Rejected",
    college: "-",
    district: "Bardhaman",
    state: "West Bengal",
    achievement: "No",
    stream: "Engineering",
    evaluationStatus: "no",
  },
  {
    appId: 10010,
    name: "Mousumi Pal",
    phone: "+91-9831001234",
    status: "Approved",
    college: "The Sanskrit College and University",
    district: "Kolkata",
    state: "West Bengal",
    achievement: "Yes",
    stream: "Arts",
    evaluationStatus: "yes",
  },
];
